const types = {
    UPDATE_FAILED: "POS_API/UPDATE_FAILED",
    UPDATE_REQUEST: "POS_API/UPDATE_REQUEST",
    UPDATE_SUCCESS: "POS_API/UPDATE_SUCCESS",
};

export default types;
